<template>
  <section>
    <b-row class="mt-4 mb-0">
      <b-col cols="4"><p class="milestoneLabel">Milestone</p></b-col>
      <b-col cols="4"><p class="milestoneLabel">Planned Date</p></b-col>
      <b-col cols="4"><p class="milestoneLabel">Actual Date</p></b-col>
    </b-row>
    <hr class="solid mt-0" />
    <b-row v-for="milestone in siteMilestones" :key="milestone.id">
      <b-col class="mb-2" cols="4">
        <p :class="[labelClass(milestone)]">
          <b-icon v-if="milestone.isNextDate" icon="dot" scale="4" variant="success"></b-icon>
          {{ milestone['milestoneName'] }}
        </p>
      </b-col>
      <b-col class="mb-2" cols="4"
        ><p class="milestoneLabel">{{ milestone['plannedDate'] || '---' }}</p></b-col
      >
      <b-col class="mb-2" cols="4"
        ><p :class="milestone['actualDate'] ? 'actualText' : 'plannedText'">
          {{ milestone['actualDate'] }}
        </p></b-col
      >
    </b-row>
  </section>
</template>
<script>
  export default {
    name: 'site-milestones',
    props: {
      siteMilestones: {},
    },
    methods: {
      labelClass(milestone) {
        return milestone['actualDate'] ? 'milestoneText' : 'plannedText';
      },
    },
  };
</script>
